import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { shallowEqual, useSelector } from 'react-redux';
import classNames from 'classnames';

// TODO: break this up later
// TODO: we will want to virtualize this or paginate
const ConversionList = ({ filterPartner }) => {
    const conversionOverview = useSelector(getConversions, areConversionsEqual);
    const {
        filterTrial,
        filterFinal,
        filterPastDue,
        filterOneWeek,
        filterLater,
        filterComplete,
    } = useSelector((state) => ({
        filterTrial: state.conversions.filterTrial,
        filterFinal: state.conversions.filterFinal,
        filterPastDue: state.conversions.filterPastDue,
        filterOneWeek: state.conversions.filterOneWeek,
        filterLater: state.conversions.filterLater,
        filterComplete: state.conversions.filterComplete,
    }), shallowEqual);
    
    return (
        <div
            className="px-2"
            style={{
                minHeight: '454px',
                maxHeight: '454px',
                overflowX: 'hidden',
                overflowY: 'scroll',
            }}>
            {conversionOverview
                ?.filter(
                    (x) =>
                        (filterTrial === false ||
                            (x.isComplete === false &&
                                x.trialComplete === false)) &&
                        (filterFinal === false || x.trialComplete === true) &&
                        (filterPastDue === false ||
                            (x.isComplete === false &&
                                dateIsPastDue(
                                    x.trialComplete === false
                                        ? x.trialTargetDate
                                        : x.finalTargetDate
                                ))) &&
                        (filterOneWeek === false ||
                            (x.isComplete === false &&
                                dateIsLessThanOneWeekOut(
                                    x.trialComplete === false
                                        ? x.trialTargetDate
                                        : x.finalTargetDate
                                ))) &&
                        (filterLater === false ||
                            (x.isComplete === false &&
                                !dateIsPastDue(
                                    x.trialComplete === false
                                        ? x.trialTargetDate
                                        : x.finalTargetDate
                                ))) &&
                        (filterComplete === false || x.isComplete === true) &&
                        (filterPartner === '' ||
                            x.partnerOfferingId === filterPartner)
                )
                .map((c, x) => (
                    <Link
                        to={`/practices/${c.practiceId}`}
                        // TODO: modify endpoint to return conversion ID
                        key={`${x}-${c.practiceId}`}
                        className={classNames(
                            'd-flex py-2 mb-2 border-on-hover hoverable unselectable',
                            { 'sc-glass': x % 2 === 0 }
                        )}
                        style={{ textDecoration: 'none', color: 'white' }}>
                        <div className="w-50 hide-overflow px-2">
                            <p
                                className="text-nowrap hide-overflow p-0 m-0"
                                title={c.practice}>
                                {c.practice}
                            </p>
                            <p className="op-7 text-12 text-nowrap hide-overflow p-0 m-0">
                                {c.partnerOffering}
                            </p>
                        </div>
                        <div className="d-flex w-66 px-2 justify-content-between">
                            <div
                                id="conversionMilestoneTitle"
                                className="w-33 text-center hide-overflow"
                                title={
                                    c.trialComplete === true
                                        ? c.finalComplete === true
                                            ? 'Completed Conversion'
                                            : 'Final'
                                        : 'Trial'
                                }>
                                {c.isComplete === true
                                    ? 'Complete'
                                    : c.trialComplete === true
                                    ? 'Final'
                                    : 'Trial'}
                                <span
                                    className={classNames({
                                        'd-none': c.isComplete === false,
                                    })}>
                                    &nbsp;
                                    <FontAwesomeIcon icon={faCheck} />
                                </span>
                            </div>
                            &emsp;
                            <div
                                id="conversionMilestoneTitle"
                                className="text-nowrap w-33 text-center hide-overflow">
                                {renderConversionStatus(c)}
                            </div>
                            &emsp;
                            <div
                                id="conversionMilestoneTarget"
                                className="text-nowrap w-33 text-right hide-overflow"
                                title={
                                    c.finalComplete === true
                                        ? `Conversion supported through ${moment
                                              .unix(c.supportEndDate)
                                              .format('MM/DD/YYYY')}`
                                        : c.trialComplete === false
                                        ? `Trial due ${moment
                                              .unix(c.trialTargetDate)
                                              .format('MM/DD/YYYY')}`
                                        : `Final due ${moment
                                              .unix(c.finalTargetDate)
                                              .format('MM/DD/YYYY')}`
                                }>
                                &nbsp;{renderConversionTarget(c)}
                            </div>
                        </div>
                    </Link>
                ))}
            <div className="op-7 my-3 py-2 text-center border-top">
                That's all for conversions
            </div>
        </div>
    );
};
const getConversions = (state) => state.conversions.conversionOverview;

const areConversionsEqual = (newConversionsList, oldConversionsList) => {
    if(oldConversionsList.length !== newConversionsList.length) return false;
    const conversionEqualityCheck = (oldConversion) => {
        const compareConversion = (newConversion) => {
            return shallowEqual(newConversion, oldConversion);
        };
        return newConversionsList.some(compareConversion);
    };
    const compareConversion = !!oldConversionsList.length && oldConversionsList.every(conversionEqualityCheck);
    const isSameConversionList = !!newConversionsList.length && compareConversion;
    return isSameConversionList;
};

const getConversionStep = (percentage) => {
    switch (percentage) {
        case 0.0:
            return 'Gather Data';
        case 0.25:
            return 'Conversion';
        case 0.5:
            return 'Q.A.';
        case 0.75:
            return 'Delivery';
        case 1.0:
            return 'Complete';
        default:
            return 'Invalid Step';
    }
};
  
const renderConversionStatus = (conversion) => {
    if (conversion.isComplete === true) return 'Support';
    if (conversion.trialComplete === false) {
        return getConversionStep(conversion.trialPercentageComplete);
    } else if (conversion.finalComplete === false) {
        return getConversionStep(conversion.finalPercentageComplete);
    } else if (conversion.isComplete === true) return 'Complete';
};

// utcnow is > date
const dateIsPastDue = (date) => moment.utc() > moment.unix(date);

// before now and less than 1 week out
const dateIsLessThanOneWeekOut = (date) =>
    moment.utc() < moment.unix(date) &&
    moment.utc().add(1, 'weeks') > moment.unix(date);

const renderConversionTarget = (conversion) => {
    if (conversion.isComplete === true)
        return getConversionTarget(conversion.supportEndDate, true);
    if (conversion.trialComplete === false) {
        return getConversionTarget(conversion.trialTargetDate);
    } else if (conversion.finalComplete === false) {
        return getConversionTarget(conversion.finalTargetDate);
    }
};

const getConversionTarget = (target, complete = false) => (
    <span
        className={classNames('p-1 px-2 sc-rounded', {
            'bg-success': complete,
            'bg-danger':
                !complete && (dateIsPastDue(target) || target === 0),
            'bg-warning': !complete && dateIsLessThanOneWeekOut(target),
            'bg-primary':
                !complete &&
                !dateIsPastDue(target) &&
                !dateIsLessThanOneWeekOut(target),
        })}>
        {target !== 0
            ? moment.unix(target).format('MM/DD/YYYY')
            : 'No Date'}
    </span>
);

export default ConversionList;
